import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useCallback, useEffect, useState } from 'preact/compat';
import Dropdown from 'react-dropdown';
import { useController, useFormContext, } from 'react-hook-form';
import { clsx } from 'clsx';
import FormLabel from '@enquiryForm/components/FormLabel';
import FormGroup from '@enquiryForm/components/FormGroup';
import FormError from '@enquiryForm/components/FormError';
function DropdownInput(props) {
    const { inputAttrs, labelAttrs, forceError } = props;
    const { name, className: forwardedInputClasses, options, value: overrideValue, } = inputAttrs;
    const { control } = useFormContext();
    const { field: { onChange, value }, fieldState: { error, invalid, isTouched }, } = useController({
        name,
        control,
    });
    const getSelectedOption = useCallback(() => (value ? (options.find((option) => option.value === value) ?? undefined) : undefined), [value]);
    const [selectedOption, setSelectedOption] = useState(getSelectedOption);
    useEffect(() => { setSelectedOption(getSelectedOption); }, [overrideValue]);
    const className = clsx('ppcform__input', forwardedInputClasses, { invalid: invalid && isTouched });
    const handleChange = (changedValue) => {
        setSelectedOption(changedValue);
    };
    useEffect(() => {
        if (selectedOption) {
            onChange(selectedOption.value);
        }
    }, [onChange, selectedOption]);
    if (!options || !options.length) {
        return null;
    }
    return (_jsxs(FormGroup, { className: error ? 'form__group--error' : '', children: [_jsx(FormLabel, { ...labelAttrs }), _jsx(Dropdown, { ...inputAttrs, className: className, onChange: handleChange, value: selectedOption, options: options }), _jsx("input", { type: "hidden", name: name, value: value }), (error && (isTouched || forceError)) && (_jsx(FormError, { children: error?.message }))] }));
}
DropdownInput.defaultProps = {
    forceError: true,
};
export default DropdownInput;
